import isEqual from 'lodash/isEqual'

const isAnalyticsUpdated = (prevAnalytics, analytics) =>
  !isEqual(prevAnalytics, analytics)

export default isAnalyticsUpdated
